export const defaultState = {
  userId: null,
  authToken: null,
  name: null,
  phone: null,
  createdAt: null,
  urlFromOps: null,
};

export default function user(state = defaultState, action) {
  switch (action.type) {
    case 'SET_USER_INFO':
      return Object.assign({}, state, action.payload.operatorDetails);
    case 'AUTH_TOKEN':
      return Object.assign({}, state, {
        authToken: action.payload,
      });
    case 'RESET_USER_INFO':
      return Object.assign({}, defaultState);
    case 'RECEIVE_DATA_FROM_OPS':
      return Object.assign({}, state, {
        urlFromOps: action.payload,
      });
    default:
      return state;
  }
}
